module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_8017.7a31f08b.png";